import { Box, Typography } from '@mui/material';
import { Accordion } from 'common/ui';
import { useGetCalendarBookingQuery } from 'generated-graphql/hooks/apollo-hooks';
import { CalendarMeetingStatusChip } from 'modules/calendar/components/CalendarMeetingChip';
import { calendarBookingFormatScheduledFor } from 'modules/calendar/utils/calendarBookingUtils';
import { ConversationItem } from 'modules/conversations/types/ConversationItem';
import { useDrawer } from 'services/drawer/hooks';
import { DrawerComponentType } from 'services/drawer/types';
import { MeetingDetailsActions } from './MeetingDetailsActions';

type Props = {
  conversation: ConversationItem;
};

export const CandidateCalendarMeeting: React.FC<Props> = ({ conversation }) => {
  const { data } = useGetCalendarBookingQuery({
    variables: {
      id: conversation.calendarBookingId as string
    },
    skip: !conversation.calendarBookingId
  });
  const { openDrawer } = useDrawer();

  const handleOpenDrawer = () => {
    openDrawer({
      drawerContentType: DrawerComponentType.CalendarBookingDetailsDrawer,
      drawerComponentProps: {
        calendarBookingId: conversation.calendarBookingId
      }
    });
  };

  if (!conversation.calendarBookingId || !data?.getCalendarBooking) {
    return null;
  }

  const {
    status,
    calendarMeetingTemplate,
    startDateTime,
    endDateTime,
    organizerUserCalendar,
    noteTakerStatus
  } = data.getCalendarBooking;

  const header = (
    <>
      <Typography component="span">Meeting details</Typography>
      <Box flex={1} />
      <CalendarMeetingStatusChip
        status={status}
        noteTakerStatus={noteTakerStatus}
      />
    </>
  );

  return (
    <Accordion title={header}>
      <>
        <Typography
          sx={{
            fontSize: '14px'
          }}
        >
          {calendarMeetingTemplate?.title}
        </Typography>
        <Typography
          sx={{
            fontSize: '14px'
          }}
        >
          {calendarBookingFormatScheduledFor(startDateTime, endDateTime)}
        </Typography>
        <Typography
          sx={{
            fontSize: '14px'
          }}
        >
          Owned by {organizerUserCalendar.name}
        </Typography>
        <MeetingDetailsActions
          status={status}
          noteTakerStatus={noteTakerStatus}
          onOpenDrawer={handleOpenDrawer}
        />
      </>
    </Accordion>
  );
};
